// Espejo de las reglas de Flexible Shipping configuradas en WooCommerce (zona "España").
// Solo se usa cuando no hay método de envío disponible: carrito antes del checkout, o sin conexión.
export const SHIPPING_FALLBACK_RULES = [
	{ min: 0, cost: 4.95 },
	{ min: 50, cost: 3.84 },
	{ min: 100, cost: 3 },
	{ min: 200, cost: 0 }
]

// Las reglas de WooCommerce llegan sin ordenar y con los importes como texto.
// Solo se interpretan las reglas de tipo "value" (importe del pedido); si alguna
// usa otra condición (peso, cantidad...) no se puede evaluar aquí y se descarta todo.
const parseShippingRules = (method) => {
	const rules = method?.settings?.method_rules?.value

	if(!Array.isArray(rules) || rules.length === 0)
		return null

	const valueRules = rules.filter(rule => rule.conditions?.length === 1 && rule.conditions[0].condition_id === 'value')

	if(valueRules.length !== rules.length)
		return null

	return valueRules.map(rule => ({
		min: parseFloat(rule.conditions[0].min) || 0,
		cost: parseFloat(rule.cost_per_order) || 0
	}))
}

export const getShippingRules = (method) => parseShippingRules(method) || SHIPPING_FALLBACK_RULES

// Se selecciona por el mínimo de cada tramo, no por el máximo: los tramos de
// WooCommerce son contiguos (49.99/50, 99.99/100...) y así un subtotal
// intermedio como 49.995 nunca se queda sin tramo aplicable.
export const calculateShippingCost = (subtotal, method) => {
	const amount = parseFloat(subtotal) || 0
	const rule = getShippingRules(method)
		.filter(el => amount >= el.min)
		.sort((a, b) => a.min - b.min)
		.pop()

	return rule ? rule.cost : 0
}
